import React from "react";

const NoPage = () => {
  return (
    <div className="content-block flex bg-light p-4 rounded inbox-container">
      <h1>Error 404</h1>
      <h2>Page not found</h2>
    </div>
  );
};

export default NoPage;
